import bus from '@/utils/eventBus'

export default function () {
  bus.$on('on-uploaded-avatar', values => {
    this.onUploadedAvatar(values.response)
  })

  this.doLoad()
}



// WEBPACK FOOTER //
// ./src/app/settings/profile/resources/mounted.js